import { Flex } from '@radix-ui/themes';
import { cx } from 'class-variance-authority';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { StarIcon } from 'shared/icons';

import './rating.scss';

interface RatingProps {
   maxRating?: number;
   initialRating?: number;
   onRatingChange?: (rating: number) => void;
   readonly?: boolean;
   showNumber?: boolean;
}

function RatingView({
   maxRating = 5,
   initialRating = 0,
   onRatingChange,
   readonly = false,
   showNumber = false,
}: RatingProps) {
   const [rating, setRating] = useState(initialRating);
   const [hoverRating, setHoverRating] = useState(0);

   const handleClick = (value: number) => {
      if (readonly) return;
      setRating(value);
      onRatingChange?.(value);
   };

   return (
      <Flex className='rating'>
         {Array.from({ length: maxRating }, (_, index) => {
            const value = index + 1;
            const isFilled = value <= (hoverRating || rating);

            return (
               <button
                  key={value}
                  type="button"
                  disabled={readonly}
                  onClick={() => handleClick(value)}
                  onMouseEnter={() => !readonly && setHoverRating(value)}
                  onMouseLeave={() => !readonly && setHoverRating(0)}
                  className="rating-button"
                  aria-label={`Rate ${value} out of ${maxRating}`}
               >
                  <StarIcon
                     color={isFilled ? 'var(--amber-7)' : 'var(--gray-7)'}
                     width={20}
                     height={20}
                  />
               </button>
            );
         })}

         {rating > 0 && showNumber && (
            <span className="ml-2 text-sm font-medium text-muted-foreground">
               {rating}/{maxRating}
            </span>
         )}
      </Flex>
   );
}

export const Rating = observer(RatingView);
